import React, { ElementType, forwardRef, HTMLAttributes, ReactNode, useContext } from 'react'
import classNames from 'classnames'
import { SlidePanelContext } from './SlidePanel'
import { CloseButton } from '../CloseButton'
import { Text } from '../Text'

export interface SlidePanelHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
    className?: string
    title?: ReactNode
    titleTag?: ElementType
    /** Add a close button to the header */
    closeButton?: boolean
    /** Additional actions to show in the header */
    actions?: ReactNode
}

const SlidePanelHeader = forwardRef<HTMLDivElement, SlidePanelHeaderProps>(({
    title,
    titleTag = 'h5',
    children,
    className,
    closeButton = true,
    actions,
    ...otherProps
}, ref) => {

    const { handleClose, headerId } = useContext(SlidePanelContext)
    const _className = classNames('slidepanel-header', className)

    return (
        <div
            ref={ref}
            className={_className}
            {...otherProps}
        >
            {title ? (
                <Text
                    tag={titleTag}
                    heavy
                    className="text-capitalize"
                    id={headerId}  // This provides the label for the panel
                >
                    {title}
                </Text>
            ) : (
                <div id={headerId}>
                    {children}
                </div>
            )}

            <div className="d-flex align-items-center">
                {actions}
                {closeButton && (
                    <CloseButton onClick={handleClose} />
                )}
            </div>
        </div>
    )
})

SlidePanelHeader.displayName = 'SlidePanelHeader'

export { SlidePanelHeader }
